module.exports = __webpack_public_path__ + "img/14.73be9f87.png";